import DescriptionList, { DescriptionListItem, DescriptionListSection } from "./DescriptionList";

export { DescriptionListItem, DescriptionListSection };
export default DescriptionList;
